export const UPDATE_LOG_OUT_FROM_APP = "UPDATE_LOG_OUT_FROM_APP";
export const UPDATE_LOG_OUT_FROM_APP_SUCCESS = "UPDATE_LOG_OUT_FROM_APP_SUCCESS";
export const UPDATE_LOG_OUT_FROM_APP_FAIL = "UPDATE_LOG_OUT_FROM_APP_FAIL";
export const SEND_CANCELTION_EMAIL = "SEND_CANCELTION_EMAIL";
export const SEND_CANCELTION_EMAIL_SUCCESS = "SEND_CANCELTION_EMAIL_SUCCESS";
export const SEND_CANCELTION_EMAIL_FAIL = "SEND_CANCELTION_EMAIL_FAIL";
